import { get, post, put, del, getBlob } from "@/utils/api";

export const SettingAPI = {
    getSettings: async () => {
        return await get(`/settings`);
    },
    save: async (params) => {
        return await post(`/settings`, params);
    }
}

export const UserAPI = {
    login: async (username, password) => {
        return await post("/user/login", { username: username, password: password });
    },
    logout: async () => {
        return await post("/user/logout");
    },
    isLogged: async () => {
        return await get("/user/login");
    },
    info: async () => {
        return await get("/user");
    },
    add: async (params) => {
        return await put("/user", params);
    },
    update: async (params) => {
        return await post(`/user/${params.id}`, params);
    },
    delete: async (id) => {
        return await del(`/user/${id}`, null);
    },
    resetPassword: async (id) => {
        return await post(`/user/password/default/${id}`);
    },
    changePassword: async (params) => {
        return await post(`/user/password/change`, params);
    },
    changePasswordNonLogin: async (params) => {
        return await put(`/user/non-login-password/change`, params);
    },
    applyResetPassword: async (username) => {
        return await put(`/user/apply-reset-password/${username}`);
    }
};

export const CompanyAPI = {
    list: async (page, query) => {
        let params = {
            page: page,
            ...query
        }
        return await get("/company", params);
    },
    active: async () => {
        return await get("/company/active");
    },
    info: async () => {
        return await get("/company/info");
    },
    add: async (params) => {
        return await put("/company", params);
    },
    update: async (companyId, params) => {
        if (typeof companyId === 'number') {
            return await post("/company/" + companyId, params);
        } else {
            params = companyId;
            return await post("/company", params);
        }
    },
    users: async (companyId) => {
        return await get("/company/user?companyId=" + (companyId ?? ""));
    },
    addUser: async (params) => {
        return await put("/company/user", params);
    },
    deleteUser: async (id) => {
        return await del(`/company/user/${id}`);
    },
    addresses: async (vendorId) => {
        return await get("/company/ship-address", { vendorId: vendorId });
    },
    register: async (params) => {
        return await put("/company/register", params);
    }
};

export const FileAPI = {
    getFile: async (url) => {
        return await getBlob(url);
    }
};

export const ContactAPI = {
    submitMessage: async (params) => {
        return put(`/contact/message`, params);
    }
}

export const UserProfileAPI = {
    get: async (type) => {
        return get(`/user-profile`, { userProfileType: type });
    },
    save: async (params) => {
        return post("/user-profile", params);
    }
}

export const NotificationAPI = {
    getUnreadCount: async () => {
        return await get('/notification/unread-count');
    },
    getNotifications: async (params) => {
        return await get('/notification', params);
    },
    markAsRead: async (id) => {
        return await post(`/notification/${id}/read`);
    },
    markAllAsRead: async () => {
        return await post('/notification/read-all');
    }
}

export const ScheduledJobAPI = {
    getAllJobs: async () => {
        return await get('/jobs');
    },
    updateJob: async (params) => {
        return await post('/jobs', params);
    },
    toggleJob: async (id, enabled) => {
        return await post(`/jobs/${id}/toggle?enabled=${enabled}`);
    },
    triggerJob: async (jobKey) => {
        return await post(`/jobs/${jobKey}/trigger`);
    },
    getJobLogs: async (params) => {
        return await get('/jobs/logs', params);
    }
}
